<template>
  <div class="container">
    <div class="find_wrap">
      <div class="tab_area">
        <div id="" class="on">STEP 01. 아이디 찾기</div>
        <div id="" class="">STEP 02. 아이디 확인</div>
      </div>
      <div class="find_form find_form_id">
        <div class="find_title">
          가입 시 입력하신 휴대폰 번호 또는 이메일주소를 통해 아이디를 찾을 수
          있습니다.
        </div>
        <div class="find_type">
          <input id="send_type" type="hidden" />
          <div
            id="phone"
            class="types on"
            attr-find="phone"
            value="phone"
            @click="toggleType('sms')"
          >
            휴대폰 번호로 찾기
          </div>
          <div
            id="email"
            class="types"
            attr-find="email"
            value="email"
            @click="toggleType('email')"
          >
            이메일 주소로 찾기
          </div>
        </div>
        <div class="form_area">
          <form id="find" @submit.prevent="sendData()">
            <table class="table_style_1">
              <tbody>
                <tr>
                  <th><span>*</span>이름</th>
                  <td>
                    <input
                      id="user_name"
                      v-model="userName"
                      type="text"
                      name=""
                      placeholder="이름을 입력해주세요."
                    />
                  </td>
                </tr>
                <tr class="find_types is_phone">
                  <th><span>*</span>휴대폰 번호</th>
                  <td class="sendhere">
                    <div class="input_area">
                      <input
                        id="user_phone"
                        v-model="hypenPhoneNum"
                        type="text"
                        class="with_btn"
                        name=""
                        maxlength="13"
                        placeholder="휴대폰 번호를 입력해 주세요."
                        @input="filterPHnum"
                      />
                      <div
                        id="code_send"
                        class="btn btn_basic"
                        :class="{ disabled: !isPhoneButtonEnabled }"
                        :disabled="!isPhoneButtonEnabled"
                        @click="sendOtp('sms')"
                      >
                        인증번호 받기
                      </div>
                    </div>
                  </td>
                </tr>
                <tr class="find_types is_email" style="display: none">
                  <th><span>*</span>이메일 주소</th>
                  <td class="sendhere">
                    <div class="input_area">
                      <input
                        id="user_email"
                        v-model="userEmail"
                        type="email"
                        class="with_btn"
                        name=""
                        placeholder="메일주소를 입력해주세요."
                      />
                      <div
                        id="code_send_email"
                        class="btn btn_basic"
                        :class="{ disabled: !isEmailButtonEnabled }"
                        :disabled="!isEmailButtonEnabled"
                        @click="sendOtp('email')"
                      >
                        인증번호 받기
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th><span>*</span>인증번호</th>
                  <td>
                    <input
                      id="user_code"
                      v-model="userCode"
                      type="text"
                      name=""
                      placeholder="인증번호를 입력해주세요."
                      maxlength="6"
                      :disabled="!isOtpInputEnabled"
                    />
                    <span
                      v-if="sendWay === 'email'"
                      id="code_count_email"
                      class="time_count"
                      >--:--</span
                    >
                    <span
                      v-if="sendWay === 'sms' || sendWay === ''"
                      id="code_count"
                      class="time_count"
                      >--:--</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="btn_area">
              <a href="/login" class="btn_orange btn_cancel">취소</a>
              <input
                type="button"
                class="btn_orange"
                value="아이디 찾기"
                @click="sendData()"
              />
            </div>
          </form>
        </div>
        <div class="Modals">
          <ModalAlert
            :alert-msg="errMsg"
            :is-open="errStatus"
            @update:is-open="updateStatus"
          ></ModalAlert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { letFindIdMasking, sendOtpNumber } from '../api/find'
import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'FindIDViews',
  components: {
    ModalAlert,
  },
  setup() {
    const router = useRouter()

    const errMsg = ref('')
    const errStatus = ref(false)

    const sendWay = ref('')

    const userName = ref('')
    const userPhone = ref('')
    // 포맷된 전화번호
    const hypenPhoneNum = ref('')
    const userEmail = ref('')
    const userCode = ref('')

    const isOtpInputEnabled = ref(false) // 인증번호 입력 칸 비활성화 여부
    const isOtpSent = ref(false) // 인증번호가 전송되었는지 여부

    const isPhoneButtonEnabled = computed(
      () => userName.value && userPhone.value
    )
    const isEmailButtonEnabled = computed(
      () => userName.value && userEmail.value
    )

    const toggleType = (type) => {
      sendWay.value = type
      // console.log('type', type)
      // console.log('sendWay.value', sendWay.value)
      if (type === 'sms') {
        sendWay.value = 'sms'
      } else if (type === 'email') {
        sendWay.value = 'email'
      }
    }
    const filterPHnum = (event) => {
      // 숫자만 남기고 하이픈을 넣는 로직
      const input = event.target.value.replace(/\D/g, '')
      if (input.length <= 3) {
        hypenPhoneNum.value = input
      } else if (input.length <= 7) {
        hypenPhoneNum.value = `${input.slice(0, 3)}-${input.slice(3)}`
      } else {
        hypenPhoneNum.value = `${input.slice(0, 3)}-${input.slice(3, 7)}-${input.slice(7)}`
      }
      // 하이픈 제거한 값을 userPhone에 저장
      userPhone.value = input
    }
    const startTimer = () => {
      setTimeout(() => {
        isOtpInputEnabled.value = false // 타이머 끝나면 입력 칸 비활성화
      }, 180000) // 3분 타이머
    }
    const sendOtp = async (type) => {
      // eslint-disable-next-line no-use-before-define
      if (!validateInput(type)) return

      const sendOTPRes = ref('')
      if (type === 'sms') {
        sendOTPRes.value = await sendOtpNumber(
          'sms',
          userName.value,
          userPhone.value
        )
      } else if (type === 'email') {
        sendOTPRes.value = await sendOtpNumber(
          'email',
          userName.value,
          userEmail.value
        )
      }
      if (sendOTPRes.value.code === 'MB21000200') {
        localStorage.setItem('userName', userName.value)
        errStatus.value = true
        errMsg.value =
          '인증번호를 발송했습니다.<br>인증번호를 받을 수 없다면 입력하신 정보와<br>회원정보를 다시 확인해주세요.'
        isOtpInputEnabled.value = true // 인증번호 입력 칸 활성화
        isOtpSent.value = true // 인증번호 전송됨
        startTimer()
      } else if (sendOTPRes.value.code === 'MB21901400') {
        errStatus.value = true
        errMsg.value = '가입 시 등록한 이메일 주소를 입력해주세요'
      } else if (sendOTPRes.value.code === 'MB21002404') {
        errStatus.value = true
        errMsg.value =
          '가입 시 등록한 휴대폰 번호 또는 이메일 주소를 확인해주세요.'
      }
    }

    const validateInput = (type) => {
      const phonePattern = /^[0-9]{10,11}$/
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (!userName.value) {
        errMsg.value = '가입 시 등록한 이름을 입력해주세요'
        errStatus.value = true
        return false
      }
      if (type === 'sms') {
        if (!userPhone.value) {
          errMsg.value = '가입 시 등록한 휴대폰 번호를 입력해주세요'
          errStatus.value = true
          return false
        }
        if (!phonePattern.test(userPhone.value)) {
          errMsg.value = '유효한 휴대폰 번호를 입력해주세요'
          errStatus.value = true
          return false
        }
      }
      if (type === 'email') {
        if (!userEmail.value) {
          errMsg.value = '가입 시 등록한 이메일 주소를 입력해주세요'
          errStatus.value = true
          return false
        }
        if (!emailPattern.test(userEmail.value)) {
          errMsg.value = '유효한 이메일 주소를 입력해주세요'
          errStatus.value = true
          return false
        }
      }
      return true
    }

    const sendData = async () => {
      if (!validateInput()) return
      if (!isOtpSent.value) {
        errMsg.value = '인증번호를 발급받아 인증을 진행해주세요.'
        errStatus.value = true
      } else {
        try {
          const findMaskingId = await letFindIdMasking(
            userName.value,
            userPhone.value,
            userEmail.value,
            userCode.value
          )
          // console.log(findMaskingId);
          if (findMaskingId.code === 'MB21100200') {
            router.push({ name: 'FindIDMaskingView' })
          } else if (findMaskingId.status_code === 400) {
            errMsg.value =
              '인증번호가 입력되지 않았습니다.<br>발송된 인증번호를 입력해 주세요.'
            errStatus.value = true
            // eslint-disable-next-line consistent-return
            return false
          } else if (findMaskingId.status_code === 404) {
            errMsg.value =
              '잘못된 인증번호입니다.<br>발송된 인증번호를 다시 확인해 주세요.'
            errStatus.value = true
          }
        } catch (err) {
          console.log(err)
        }
      }
    }
    const updateStatus = () => {
      errStatus.value = false
    }
    watch(userName, (val) => {
      userName.value = val.replace(/\s/g, '') // 이름에서 공백 제거
    })
    watch(userPhone, (val) => {
      const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/
      // 한글, 영문 체크
      if (reg.test(val)) {
        userPhone.value = val.replace(/[^0-9]/g, '')
      }
      // 숫자 외의 문자가 입력된 경우
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(parseFloat(val))) {
        userPhone.value = ''
      }
      userPhone.value = val.replace(/\s/g, '') // 휴대폰 번호에서 공백 제거
    })
    watch(userEmail, (val) => {
      userEmail.value = val.replace(/\s/g, '') // 이메일 주소에서 공백 제거
    })
    onMounted(() => {})
    return {
      errMsg,
      errStatus,

      userName,
      userPhone,
      hypenPhoneNum,
      userEmail,
      userCode,

      isPhoneButtonEnabled,
      isEmailButtonEnabled,
      isOtpInputEnabled,
      sendData,
      updateStatus,

      toggleType,
      filterPHnum,
      sendOtp,

      sendWay,
    }
  },
}
</script>
